// Action codes for permission management
export enum ActionCode {
  TabsDetail = 'tabs:detail',
  SearchTableDetail = 'search:table:detail'
}

export const ACTION_CODES = {
  TABS_DETAIL: 'tabs:detail',
  SEARCH_TABLE_DETAIL: 'search:table:detail'
} as const;